import { logEvent, type TAnalyticArgs } from '@/containers/AnalyticsContainer';
import { useGetRouteStoryData } from '../hooks/useGetRouteStoryData';

type UseLogSlideEventReturn = {
  logSlideEvent: (__highlightNumber?: number, __slideNumber?: number) => void;
};

export const useLogSlideEvent = (
  isChangelog: boolean = false
): UseLogSlideEventReturn => {
  const { analyticsEvent } = useGetRouteStoryData(isChangelog);

  const logSlideEvent = (
    highlightNumber: number | undefined,
    slideNumber: number | undefined
  ) => {
    const shouldLogEvent = analyticsEvent && highlightNumber && slideNumber;
    if (shouldLogEvent) {
      const eventName =
        `${analyticsEvent}-h${highlightNumber}-s${slideNumber}` as TAnalyticArgs[0];
      logEvent(eventName, null);
    }
  };

  return { logSlideEvent };
};
